// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class StartTrafficLights extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 174.5, y ?? 366.5);

    // body
    const body = scene.add.image(0, 0, "game-32", "traffic-light-body.png");
    this.add(body);

    // lightOffGreen
    const lightOffGreen = scene.add.image(-12, 231, "game-32", "traffic-light-off.png");
    this.add(lightOffGreen);

    // lightGreen
    const lightGreen = scene.add.image(-12, 231, "game-32", "traffic-light-green.png");
    lightGreen.visible = false;
    this.add(lightGreen);

    // lightOffAmber
    const lightOffAmber = scene.add.image(-14, 91, "game-32", "traffic-light-off.png");
    this.add(lightOffAmber);

    // lightAmber
    const lightAmber = scene.add.image(-14, 91, "game-32", "traffic-light-amber.png");
    lightAmber.visible = false;
    this.add(lightAmber);

    // lightRed
    const lightRed = scene.add.image(-14, -45, "game-32", "traffic-light-red.png");
    this.add(lightRed);

    this.lightGreen = lightGreen;
    this.lightAmber = lightAmber;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private lightGreen: Phaser.GameObjects.Image;
  private lightAmber: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  public lowerDown() {
    this.lightAmber.setVisible(false);
    this.lightGreen.setVisible(false);
    this.scene.add.tween({
      targets: this,
      y: 320,
      duration: 750,
      ease: Phaser.Math.Easing.Cubic.Out
    });
  }

  public showAmber() {
    this.lightAmber.setVisible(true);
  }

  public showGreen() {
    this.lightGreen.setVisible(true);
  }

  public raiseUp() {
    this.scene.add.tween({
      targets: this,
      y: -400,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.In,
      onComplete: () => {
        this.lightAmber.setVisible(false);
        this.lightGreen.setVisible(false);
      }
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
